import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NewspaperIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NewspaperIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.332 6.76665H19.4246V4.80836C19.4246 3.96307 18.7394 3.27783 17.8941 3.27783H4.59645C3.75116 3.27783 3.06592 3.96307 3.06592 4.80836V17.8146C3.06592 19.4203 4.36759 20.722 5.97327 20.722H20.5876C21.8721 20.722 22.9134 19.6806 22.9134 18.3961V7.34812C22.9134 7.02698 22.6531 6.76665 22.332 6.76665ZM4.22886 17.8146V5.38983C4.22886 4.86568 4.65377 4.44077 5.17792 4.44077H17.3126C17.8368 4.44077 18.2617 4.86568 18.2617 5.38983V18.3961C18.2617 18.8196 18.376 19.2166 18.5746 19.559H5.97327C5.00986 19.559 4.22886 18.778 4.22886 17.8146ZM21.7505 18.3961C21.7505 19.0373 21.2288 19.559 20.5876 19.559C19.9463 19.559 19.4246 19.0373 19.4246 18.3961V7.92959H21.7505V18.3961Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.97327 13.7443H9.4621C9.78323 13.7443 10.0436 13.484 10.0436 13.1628V10.837C10.0436 10.5158 9.78323 10.2555 9.4621 10.2555H5.97327C5.65214 10.2555 5.3918 10.5158 5.3918 10.837V13.1628C5.3918 13.484 5.65214 13.7443 5.97327 13.7443ZM6.55474 11.4184H8.88062V12.5814H6.55474V11.4184Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5173 5.60371H5.97327C5.65214 5.60371 5.3918 5.86405 5.3918 6.18518V8.51106C5.3918 8.83219 5.65214 9.09253 5.97327 9.09253H16.5173C16.8384 9.09253 17.0987 8.83219 17.0987 8.51106V6.18518C17.0987 5.86405 16.8384 5.60371 16.5173 5.60371ZM15.9358 7.92959H6.55474V6.76665H15.9358V7.92959Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5173 12.5814H11.8655C11.5444 12.5814 11.284 12.8417 11.284 13.1628C11.284 13.484 11.5444 13.7443 11.8655 13.7443H16.5173C16.8384 13.7443 17.0987 13.484 17.0987 13.1628C17.0987 12.8417 16.8384 12.5814 16.5173 12.5814Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5173 14.9072H5.97327C5.65214 14.9072 5.3918 15.1676 5.3918 15.4887C5.3918 15.8098 5.65214 16.0702 5.97327 16.0702H16.5173C16.8384 16.0702 17.0987 15.8098 17.0987 15.4887C17.0987 15.1676 16.8384 14.9072 16.5173 14.9072Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5173 17.2331H5.97327C5.65214 17.2331 5.3918 17.4935 5.3918 17.8146C5.3918 18.1357 5.65214 18.3961 5.97327 18.3961H16.5173C16.8384 18.3961 17.0987 18.1357 17.0987 17.8146C17.0987 17.4935 16.8384 17.2331 16.5173 17.2331Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5173 10.2555H11.8655C11.5444 10.2555 11.284 10.5158 11.284 10.837C11.284 11.1581 11.5444 11.4184 11.8655 11.4184H16.5173C16.8384 11.4184 17.0987 11.1581 17.0987 10.837C17.0987 10.5158 16.8384 10.2555 16.5173 10.2555Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NewspaperIcon;
